export class Hamburger {
	constructor(header) {
		this.header    = header;
		this.nav       = header.querySelector('nav[role="navigation"]');
		this.hamburger = header.querySelector('.hamburger');
		this.hasSub    = header.querySelectorAll('.has-sub');
		this.active    = 'active';

		if(this.hamburger && this.nav) {
			this.initAddEventListener();
		}

		if(this.hasSub) {
			for(let i = 0; i < this.hasSub.length; i++) {
				let button  = this.hasSub[i].querySelector('.sub-show');
				let content = this.hasSub[i].querySelector('.sub-menu');

				if(button && content) {
					this.initAddEventListenerSub(button, content);
				}
			}
		}
	}

	initAddEventListener() {
		this.hamburger.addEventListener('click', this.eventClick.bind(this));
	}

	initAddEventListenerSub(button, content) {
		button.addEventListener('click', this.eventClickSub.bind(this, button, content));
	}

	eventClick() {
		if(this.nav.classList.contains(this.active)) {
			this.removeClass(this.nav);
			this.removeClass(this.hamburger);
		} else {
			this.addClass(this.nav);
			this.addClass(this.hamburger);
		}
	}

	eventClickSub(button, content) {
		if(content.classList.contains(this.active)) {
			this.removeClass(button);
			this.removeClass(content);
		} else {
			this.removeClickSubAll();
			this.addClass(button);
			this.addClass(content);
		}
	}

	addClass(element) {
		element.classList.add(this.active);
	}

	removeClass(element) {
		element.classList.remove(this.active);
	}

	removeClickSubAll() {
		if(this.hasSub) {
			for(let i = 0; i < this.hasSub.length; i++) {
				let button  = this.hasSub[i].querySelector('.sub-show');
				let content = this.hasSub[i].querySelector('.sub-menu');

				if(button && content) {
					this.removeClass(button);
					this.removeClass(content)
				}
			}
		}
	}
}